class QuoteComponent {
    currentIndex = 0;
    interval: NodeJS.Timeout | undefined = undefined;

    quoteElement: HTMLElement;
    singleQuoteElements: NodeListOf<HTMLQuoteElement>;
    paginationElements: NodeListOf<HTMLLIElement>;
    totalQuotes: number;

    constructor(quoteElement: HTMLElement) {
        this.quoteElement = quoteElement;
        this.singleQuoteElements = this.quoteElement.querySelectorAll('.quotes .quote');
        this.paginationElements = this.quoteElement.querySelectorAll('.quote-pagination > li');
        this.totalQuotes = this.singleQuoteElements.length;
        // Add event listeners
        this.paginationElements.forEach((paginationElement, paginationIndex) => {
            paginationElement.addEventListener('click', () => {
                this.goTo(paginationIndex);
            });
        });
        this.goTo(0, false);
    }

    goTo(index: number, userInteracted = true) {
        index = index % this.totalQuotes;
        this.singleQuoteElements.forEach((element) => {
            element.classList.remove('active', 'interacted');
        });
        this.singleQuoteElements[index]?.classList.add('active');
        if (userInteracted) {
            this.singleQuoteElements[index]?.classList.add('interacted');
        }
        this.paginationElements.forEach((element) => element.classList.remove('active'));
        if (this.paginationElements.length > 0) {
            this.paginationElements[index].classList.add('active');
        }
        this.currentIndex = index;
        this.restart();
    }

    next() {
        this.goTo(this.currentIndex + 1);
    }

    prev() {
        this.goTo(this.totalQuotes + this.currentIndex - 1);
    }

    restart() {
        if (this.interval) {
            this.pause();
            setTimeout(() => this.play());
        }
    }

    play() {
        this.quoteElement.classList.remove('paused');
        if (!this.interval) {
            this.interval = setInterval(() => {
                this.next();
            }, 6000);
        }
    }

    pause() {
        this.quoteElement.classList.add('paused');
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}

function initializeQuoteComponents(rootElement = document) {
    const quoteContainers = rootElement.getElementsByClassName('quote-container');
    for (let i = 0; i < quoteContainers.length; i++) {
        const component = new QuoteComponent(quoteContainers.item(i) as HTMLElement);
        component.pause();
    }
}

window.addEventListener('load', () => {
    initializeQuoteComponents();
});

